export enum AuthenticationStatuses {
  NONE = 'NONE',
  AUTHENTICATING = 'AUTHENTICATING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}
